import { Injectable, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CookieNames, BasicRoutes, ApiEndpoints, ErrorText, Gtype } from '../../core-modules/constant';
declare var $: any;
import { DOCUMENT } from '@angular/platform-browser';
import { CookieManagerService } from './cookie-manager.service';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class RegistrationFeeService {
  // public registrationFeeToken: any = '98b76bbb-6980-40f5-bb61-033feccc8568';
  public registrationFeeToken: any = false;
  public checkUserSet = new Subject<any>();

  constructor(
    private cookieManagerService: CookieManagerService,
    private httpClientService: HttpClientService,
  ) {
    this.cookieManagerService = cookieManagerService,
      this.httpClientService = httpClientService
  }

  setRegistrationTokenForFee(token) {
    this.getRegistrationFeeDetailsForUser(token, callback => {
      this.registrationFeeToken = token;
      this.cookieManagerService.setCookie(CookieNames.registrationCode, token);
      return true;
    });
    
  }
  getRegistrationTokenForFee() {
    return this.registrationFeeToken;
  }

  setSendUserExitDetials(value) {
    this.checkUserSet.next({ value });
    // this.checkUserSet = value;
  }

  getSendUserExitDetials(): Observable<any> {
    return this.checkUserSet.asObservable();
  }


  /**
   * get registration details
   */
  // getRegistrationFee(){
  //   this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getRegistrationFee, { }), null).subscribe(
  //     res => {
  //       return res;
  //     }, e => {

  //     });
  // } 

  /**
   * get registration details
   */
  getRegistrationFeeDetailsForUser(token, callback) {
    let registerFee = 0;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getRegistrationFeeGForUser, { [ApiEndpoints.registrationToken]: token }), null).subscribe(
      res => {
        if ((res['registerFee'] || false)) {
          this.cookieManagerService.setCookie(CookieNames.registrationFee, res['registerFee']);
          callback(res['registerFee']);
          return true;
        } else {
          callback(registerFee);
          return false;
        }
      }, e => {
        callback(registerFee);
        return false;
      });
      callback(registerFee);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/registration-fee.service.ts